import axios from 'axios';

export function pdaGetAll({page, limit, filter}) {
    return axios({
        method: 'post',
        url: '/api/v1/prices/pdaCustomAll',
        data: {
            page,
            limit,
            filter,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function pdaUpdate(data) {
    return axios({
        method: 'put',
        url: '/api/v1/prices/pdaCustom',
        data,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function pdaDelete(_id) {
    return axios({
        method: 'delete',
        url: '/api/v1/prices/pdaCustom',
        data: {
            _id
        },
        withCredentials: true,
    })  
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function pdaAdd(data) {
    return axios({
        method: 'post',
        url: '/api/v1/prices/pdaCustom',
        data: {
            ...data,
            userEntry: false,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);;
}



// WEBPACK FOOTER //
// ./app/services/prices.js